import React from 'react';
import '@/App.css';
import './styles.css';
import './hero-enhancements.css';
import './portfolio-trial.css';
import './portfolio-immersive.css';
import { MotionConfig } from 'framer-motion';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useSmoothScroll } from './hooks/useSmoothScroll';

// Components
import Header from './components/Header';
import Hero from './components/Hero';
import ArchitecturalHero from './components/ArchitecturalHero';
import About from './components/About';
import Skills from './components/Skills';
import Projects from './components/Projects';
import TechStack from './components/TechStack';
import Certifications from './components/Certifications';
import GithubFeed from './components/GithubFeed';
import Resume from './components/Resume';
import Contact from './components/Contact';
import Footer from './components/Footer';
import WhatsAppBubble from './components/WhatsAppBubble';
import Admin from './pages/Admin';
import Blogs from './pages/Blogs';
import PointerAccent from './components/PointerAccent';
import InteractiveMascot from './components/mascot/InteractiveMascot';
import SpaceExperience from './components/SpaceExperience';
import InterstellarHero from './components/InterstellarHero';

function Home() {
  const baseline = new URLSearchParams(window.location.search).get('design') === 'baseline';
  const immersive = !baseline && new URLSearchParams(window.location.search).get('design') !== 'editorial';
  useSmoothScroll(immersive);
  const content = <>
    <a className="portfolio-skip" href="#portfolio-main">Skip to content</a>
    <Header />
    <main id="portfolio-main" tabIndex={-1}>
      {immersive ? <InterstellarHero /> : baseline ? <Hero /> : <ArchitecturalHero />}
      <About />
      <Skills />
      <Projects />
      <TechStack />
      <Certifications />
      <GithubFeed />
      <Resume />
      <Contact />
    </main>
    <Footer />
    <WhatsAppBubble />
    {immersive && <PointerAccent />}
  </>;
  return immersive ? <SpaceExperience>{content}</SpaceExperience> :
    <MotionConfig reducedMotion="user"><div className={baseline ? 'portfolio-baseline' : 'portfolio-trial'}>{content}</div></MotionConfig>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/v2" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/blogs" element={<Blogs />} />
        </Routes>
        <InteractiveMascot />
      </BrowserRouter>
    </div>
  );
}

export default App;
